<div class="dialog-content-wrapper">
    <mat-toolbar matDialogTitle class="mat-accent m-0">
        <mat-toolbar-row fxLayout="row" fxLayoutAlign="space-between center">
            <span class="title dialog-title">
                Ponowienie wydruku
            </span>
        </mat-toolbar-row>
    </mat-toolbar>

    <div mat-dialog-content class="p-24 pb-0 m-0" fusePerfectScrollbar>
        <div class="invoice tab-content" fusePerfectScrollbar>

            <div id="invoice" class="compact page-layout blank" fxLayout="row" fusePerfectScrollbar>

                <div class="invoice-container">

                    <!-- INVOICE -->
                    <div class="card">
                        Czy chcesz ponowić wydruk paragonu/faktury?
                    </div>
                </div>
            </div>
        </div>
    </div>

    <div mat-dialog-actions class="m-0 p-16" fxLayout="row" fxLayoutAlign="end center">

        <button
                mat-button
                class="mr-8"
                (click)="matDialogRef.close()"
                aria-label="Cancel">
            {{'Cancel'|translate}}
        </button>
        <button
                mat-button
                class="mr-8"
                (click)="matDialogRef.close('confirm')"
                aria-label="Confirm"
        >
            {{'Confirm'|translate}}
        </button>

    </div>
</div>
